module.exports = __webpack_public_path__ + "img/shot_tx19112004.a939aa33.jpg";